var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDhconstlit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 514,
    height: 218,
    viewBox: "0 0 514 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.095 25.7227L283 55.0003",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349 101L296.281 157.83",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M445.412 46.8092L396 102.823",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M507.072 115.324L387.69 115.242",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.047 184.103L459.475 39.9881",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357.488 87.572L337 39",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M364.509 163.97L288.711 169.95",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 49.0002C50.521 40.5435 102.558 34.7963 120.291 69.4188C126.727 89.8142 132.05 139.153 84 169",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeDasharray: "21.58 21.58"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0957 61.3105L72.5077 176.546",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.735 48.7944L158.829 175.683",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.805 108.369L229.745 80.2546",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M244.548 22.2454L225.992 176.232",
    stroke: "white",
    strokeWidth: 10.3583,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "21.58 21.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDhconstlit);
export default __webpack_public_path__ + "static/media/dhconstlit.fe47c20dadc42326af836055d24ecffa.svg";
export { ForwardRef as ReactComponent };